import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { ApplicationContextService, RolePermissionService } from 'lib-core-shared';
import { ControlBaseDirective } from '../../directives/control-base.directive';

@Component({
  selector: 'lib-file-picker-box',
  templateUrl: './file-picker-box.component.html',
  styleUrls: ['./file-picker-box.component.css']
})
export class FilePickerBoxComponent extends ControlBaseDirective {
  @ViewChild('input') public input: ElementRef | undefined;
  @Input() additionalTextLine1?: string;
  @Input() additionalTextLine2?: string;
  @Input() additionalTextLine3?: string;
  @Input() fileName?: string;
  @Input() mode?: string;
  @Output() convertedToBase64Emitter: EventEmitter<string | null> = new EventEmitter();
  private file: File | null = null;
  public fileUploadedAgain: boolean = false;

  constructor(public roleService: RolePermissionService, public applicationContext: ApplicationContextService) {
    super(roleService, applicationContext);
  }
 
  @HostListener('change', ['$event.target.files'])
  emitFiles(event: FileList) {
    if (event?.length) {
      this.file = event[0];
      this.fileUploadedAgain = true;
    } else {
      this.file = null;
      this.fileUploadedAgain = false;
    }

    
    
    if (this.file) {
      const reader = new FileReader();

      reader.onload = () => {
        let readerResult = reader.result as string;
        const regex = /data:.*base64,/;

        this.convertedToBase64Emitter.emit(readerResult.replace(regex, ''));
        this.control.setValue(this.file);
        this.control.markAsDirty();
      }

      reader.readAsDataURL(this.file);
    } else {
      this.convertedToBase64Emitter.emit(null);
      this.control.setValue(this.file);
      this.control.markAsPristine();
    }
  }

  resetFile() {
    this.fileUploadedAgain = false;
  }

  fileSelector() {
    if(this.mode === 'edit' && !this.fileUploadedAgain) {
      this.fileUploadedAgain = true;
    }
    if (this.input) {
      this.input.nativeElement.click();
    }
    this.fileUploadedAgain = false;
  }

  resetFunction(i: number) {
    let inputForm: any = document.getElementsByClassName('input-form');

    if (inputForm[i]) {
      inputForm[i].reset();
      this.convertedToBase64Emitter.emit(null);
      this.control.setValue(null);
      this.file = null;
    }
  }
}
